function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, JSON, Object, validationError) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['auth-banners'] = function({
      success,
      info,
      error
    }) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((success) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-auth-banner-container': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-banner", {
              "attrs": __vjadeStringifyAttrsIfObj({
                id: `success-banner`,
                theme: `success`,
                size: `small`,
                type: `embedded`,
                'body-text': success,
              }),
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);
        __jade_nodes = __jade_nodes.concat((info) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-auth-banner-container': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-banner", {
              "attrs": __vjadeStringifyAttrsIfObj({
                id: `info-banner`,
                theme: `info`,
                size: `medium`,
                type: `embedded`,
                'body-text': info,
              }),
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);
        __jade_nodes = __jade_nodes.concat((error) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-auth-banner-container': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-banner", {
              "attrs": __vjadeStringifyAttrsIfObj({
                id: `error-banner`,
                theme: `warn`,
                size: `medium`,
                type: `embedded`,
                'body-text': error,
              }),
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['recaptcha'] = function(recaptchaKey) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "key": 'g-recaptcha',
          "attrs": __vjadeStringifyAttrsIfObj({
            id: `recaptcha`,
            class: `g-recaptcha `,
            'data-sitekey': recaptchaKey,
            'data-size': `invisible`,
            'data-error-callback': `handleRecaptchaError`,
            'data-callback': `handleRecaptchaResponse`,
          }),
          "class": {
            'recaptcha': true
          },
        }));;
        return __jade_nodes
      }).call(this);
    };

    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }
    return {
      value: (h("auth-container", {
        "attrs": __vjadeStringifyAttrsIfObj({
          'show-footer-links': true,
        }),
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "attrs": __vjadeStringifyAttrsIfObj({
            slot: `auth-form-slot`
          }),
          "class": {
            'auth-form': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(jade_mixins['auth-banners'].call(this, {
            error: $attr(`error-message`),
            success: $attr(`success-message`)
          }));
          __jade_nodes = __jade_nodes.concat(h("form", {
            "attrs": __vjadeStringifyAttrsIfObj({
              action: `/forgot-password/`,
              method: `post`,
            }),
            "hook": {
              insert: $helpers.onFormInserted,
            },
            "on": {
              submit: $helpers.handleSubmit,
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("h1", {
              "class": {
                'auth-form-title': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Forgot password?");;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("p", {
              "class": {
                'auth-form-description': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Don’t worry! Fill in your email and we’ll send you a link to reset your password.");;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(jade_mixins['recaptcha'].call(this, $attr(`recaptcha-key`)));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'auth-form-field-row': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-shadowless-input", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  'field-name': `email`,
                  'validation-status': validationError ? `invalid` : ``,
                  'error-message': validationError,
                  label: `Email Address`,
                  placeholder: `e.g. eleanor@mixpanel.com`,
                }),
                "on": {
                  input: $helpers.handleEmailInput,
                  blur: $helpers.handleEmailBlur,
                },
                "hook": {
                  insert: ({
                    elm
                  }) => elm.focus()
                },
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'auth-form-field-row': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-button", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  theme: `primary`,
                }),
                "on": {
                  click: $helpers.handleSubmitClick,
                },
                "class": {
                  'send-email': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Send Email");;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            const next = $attr(`next`) ? `?next=${$attr(`next`)}` : ``;;
            __jade_nodes = __jade_nodes.concat(h("a", {
              "attrs": __vjadeStringifyAttrsIfObj({
                href: `/login/${next}`,
              }),
              "class": {
                'auth-link': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Back to Login");;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("input", {
              "attrs": __vjadeStringifyAttrsIfObj({
                type: `hidden`,
                name: `csrfmiddlewaretoken`,
                value: $helpers.getCsrfToken()
              }),
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "validationError" in locals ? locals.validationError : typeof validationError !== "undefined" ? validationError : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;